import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { typeDetails } from "../../utils/sensors"; // Path relativo al file con i dettagli dei sensori
import { useSensorsMap } from "../../contexts/SensorsMapProvider";
import { FaFilter } from "react-icons/fa";
import { LuMapPinPlus } from "react-icons/lu";
import { createRoot } from "react-dom/client";
import { MdOutlineSensors } from "react-icons/md";
import { FaCircle } from "react-icons/fa";
import { CiCircleList } from "react-icons/ci";

const FilterBar = ({ canEdit, isMonitor }) => {
	const map = useMap();
	const { state, dispatch, ACTIONS } = useSensorsMap();

	// Testo della label
	const content =
		state.selectedType && typeDetails[state.selectedType]
			? `${typeDetails[state.selectedType].sensor} (${typeDetails[state.selectedType].unit})`
			: state.addPinEnabled
			? "Crea un nuovo pin"
			: "Nessun filtro selezionato";

	useEffect(() => {
		const control = L.control({ position: "topright" });

		control.onAdd = () => {
			// Contenitore principale per label e controlli
			const container = L.DomUtil.create("div", "leaflet-control-container");
			container.style.position = "relative";
			container.style.display = "flex";
			container.style.flexDirection = "column";
			container.style.alignItems = "flex-end";
			container.style.gap = "10px";

			// Contenitore per la label
			const labelContainer = L.DomUtil.create("div", "sensor-label-container", container);
			labelContainer.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
			labelContainer.style.padding = "10px 20px";
			labelContainer.style.borderRadius = "8px";
			labelContainer.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
			labelContainer.style.fontWeight = "bold";
			labelContainer.style.color = "#333";
			labelContainer.style.textAlign = "center";
			labelContainer.innerHTML = content;

			// Contenitore per i pulsanti (filtro e aggiungi pin)
			const controlsContainer = L.DomUtil.create(
				"div",
				"sensor-controls-container",
				container
			);
			controlsContainer.style.display = "flex";
			controlsContainer.style.flexDirection = "column";
			controlsContainer.style.alignItems = "flex-end";
			controlsContainer.style.gap = "10px";

			if (isMonitor) return container;

			// Pulsante Filtro
			const filterButton = L.DomUtil.create("div", "sensor-toggle-button", controlsContainer);
			filterButton.style.cursor = "pointer";
			filterButton.style.background = state.selectedType ? "#4caf50" : "#f5f5f5";
			filterButton.style.border = "1px solid #ccc";
			filterButton.style.borderRadius = "5px";
			filterButton.style.padding = "5px";
			filterButton.style.width = "40px";
			filterButton.style.height = "40px";
			filterButton.style.display = "flex";
			filterButton.style.alignItems = "center";
			filterButton.style.justifyContent = "center";

			// Icona Filtro
			const filterRoot = createRoot(filterButton);
			filterRoot.render(
				<MdOutlineSensors
					style={{
						fontSize: "20px",
						color: state.selectedType ? "white" : "#333",
					}}
				/>
			);

			// Menu Filtro
			const menuContainer = L.DomUtil.create(
				"div",
				"sensor-menu-container",
				controlsContainer
			);
			menuContainer.style.position = "absolute";
			menuContainer.style.top = "50px";
			menuContainer.style.right = "50px";
			menuContainer.style.backgroundColor = "#fff";
			menuContainer.style.border = "1px solid #ccc";
			menuContainer.style.borderRadius = "5px";
			menuContainer.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.1)";
			menuContainer.style.padding = "10px";
			menuContainer.style.display = state.filterMenuOpen === 1 ? "block" : "none";
			menuContainer.style.zIndex = "1000";
			menuContainer.style.width = "300px";

			// Due colonne per i sensori
			const columnsContainer = L.DomUtil.create("div", "columns-container", menuContainer);
			columnsContainer.style.display = "flex";
			columnsContainer.style.gap = "10px";

			// Dividi gli elementi in due colonne
			const keys = Object.keys(typeDetails);
			const midIndex = Math.ceil(keys.length / 2);
			const columns = [keys.slice(0, midIndex), keys.slice(midIndex)];

			columns.forEach((columnKeys) => {
				const column = L.DomUtil.create("div", "sensor-column", columnsContainer);
				column.style.flex = "1";

				columnKeys.forEach((key) => {
					const { label, icon: Icon } = typeDetails[key];

					const itemContainer = L.DomUtil.create("div", "sensor-item-container", column);
					itemContainer.style.display = "flex";
					itemContainer.style.alignItems = "center";
					itemContainer.style.padding = "5px";
					itemContainer.style.cursor = "pointer";
					itemContainer.style.backgroundColor =
						state.selectedType === key ? "#4caf50" : "#f5f5f5";
					itemContainer.style.transition = "background-color 0.3s ease";
					itemContainer.style.borderRadius = "5px";
					itemContainer.style.marginBottom = "5px";

					// Icona
					const iconContainer = L.DomUtil.create("div", "sensor-icon", itemContainer);
					iconContainer.style.fontSize = "24px";
					iconContainer.style.color = state.selectedType === key ? "white" : "#333";

					const iconRoot = createRoot(iconContainer);
					iconRoot.render(<Icon />);

					// Testo
					const labelContainer = L.DomUtil.create("div", "sensor-label", itemContainer);
					labelContainer.style.marginLeft = "10px";
					labelContainer.innerText = label;
					labelContainer.style.color = state.selectedType === key ? "white" : "#333";

					itemContainer.onclick = () => {
						dispatch({
							type: ACTIONS.SET_SELECTED_TYPE,
							payload: state.selectedType === key ? null : key,
						});
						dispatch({ type: ACTIONS.SET_FILTER_MENU_OPEN, payload: 0 });
					};
				});
			});

			// Pulsante Filtro Gruppi
			const groupFilterButton = L.DomUtil.create(
				"div",
				"group-filter-toggle-button",
				controlsContainer
			);
			groupFilterButton.style.cursor = "pointer";
			groupFilterButton.style.background = "#f5f5f5";
			groupFilterButton.style.border = "1px solid #ccc";
			groupFilterButton.style.borderRadius = "5px";
			groupFilterButton.style.padding = "5px";
			groupFilterButton.style.width = "40px";
			groupFilterButton.style.height = "40px";
			groupFilterButton.style.display = "flex";
			groupFilterButton.style.alignItems = "center";
			groupFilterButton.style.justifyContent = "center";

			// Icona Gruppi
			const groupFilterRoot = createRoot(groupFilterButton);
			groupFilterRoot.render(<FaFilter style={{ fontSize: "20px", color: "#333" }} />);

			// Menu Gruppi
			const groupMenuContainer = L.DomUtil.create(
				"div",
				"group-menu-container",
				controlsContainer
			);
			groupMenuContainer.style.position = "absolute";
			groupMenuContainer.style.top = "50px"; // Posiziona sotto il pulsante
			groupMenuContainer.style.right = "50px";
			groupMenuContainer.style.backgroundColor = "#fff";
			groupMenuContainer.style.border = "1px solid #ccc";
			groupMenuContainer.style.borderRadius = "5px";
			groupMenuContainer.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.1)";
			groupMenuContainer.style.padding = "10px";
			groupMenuContainer.style.display = state.filterMenuOpen === 2 ? "block" : "none";
			groupMenuContainer.style.zIndex = "1000";
			groupMenuContainer.style.width = "200px"; // Larghezza del menu

			// Itera sui gruppi di pin
			state.pinsGroups &&
				state.pinsGroups.forEach((group) => {
					const groupItem = L.DomUtil.create("div", "group-item", groupMenuContainer);
					groupItem.style.display = "flex";
					groupItem.style.alignItems = "center";
					groupItem.style.padding = "5px";
					groupItem.style.cursor = "pointer";
					groupItem.style.backgroundColor = group.selected ? "#4caf50" : "#f5f5f5";
					groupItem.style.borderRadius = "5px";
					groupItem.style.marginBottom = "5px";
					groupItem.style.color = group.selected ? "white" : "#333";
					groupItem.style.transition = "background-color 0.3s ease";

					// Contenitore per l'icona
					const iconContainer = L.DomUtil.create("div", "group-icon", groupItem);
					iconContainer.style.marginRight = "10px";
					iconContainer.style.fontSize = "16px";
					iconContainer.style.color = group.selected ? "white" : "#333";

					// Usa React per renderizzare l'icona
					const iconRoot = createRoot(iconContainer);
					iconRoot.render(<FaCircle />);

					// Testo accanto all'icona
					const labelContainer = L.DomUtil.create("div", "group-label", groupItem);
					labelContainer.innerText = group.label;

					// Gestione click sul gruppo
					groupItem.onclick = () => {
						dispatch({
							type: ACTIONS.TOGGLE_GROUP_SELECTION,
							payload: group.id,
						});
					};
				});

			// Pulsante Legenda
			const legendButton = L.DomUtil.create("div", "legend-toggle-button", controlsContainer);
			legendButton.style.cursor = "pointer";
			legendButton.style.background = "#f5f5f5";
			legendButton.style.border = "1px solid #ccc";
			legendButton.style.borderRadius = "5px";
			legendButton.style.padding = "5px";
			legendButton.style.width = "40px";
			legendButton.style.height = "40px";
			legendButton.style.display = "flex";
			legendButton.style.alignItems = "center";
			legendButton.style.justifyContent = "center";

			// Icona per il pulsante Legenda
			const legendRoot = createRoot(legendButton);
			legendRoot.render(<CiCircleList style={{ fontSize: "20px", color: "#333" }} />);

			// Contenitore della legenda
			const legendContainer = L.DomUtil.create("div", "legend-container", controlsContainer);
			legendContainer.style.position = "absolute";
			legendContainer.style.top = "50px"; // Posiziona sotto il pulsante
			legendContainer.style.right = "50px";
			legendContainer.style.backgroundColor = "#fff";
			legendContainer.style.border = "1px solid #ccc";
			legendContainer.style.borderRadius = "5px";
			legendContainer.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.1)";
			legendContainer.style.padding = "10px";
			legendContainer.style.display = state.filterMenuOpen === 3 ? "block" : "none";
			legendContainer.style.zIndex = "1000";
			legendContainer.style.width = "120px"; // Larghezza del menu

			// Titolo della legenda
			const legendTitle = L.DomUtil.create("div", "legend-title", legendContainer);
			legendTitle.style.fontWeight = "bold";
			legendTitle.style.marginBottom = "10px";
			legendTitle.style.textAlign = "center";
			legendTitle.innerText = "Legenda Sensori";

			// Elementi della legenda
			const legendItems = [
				{ color: "#4caf50", label: "Online" },
				{ color: "#015069", label: "Ritardo" },
				{ color: "#666363", label: "Offline" },
				{ color: "#dec800", label: "Pre-allerta" },
				{ color: "#de6400", label: "Allerta" },
				{ color: "#ff0000", label: "Pericolo" },
			];

			legendItems.forEach((item) => {
				const legendItem = L.DomUtil.create("div", "legend-item", legendContainer);
				legendItem.style.display = "flex";
				legendItem.style.alignItems = "center";
				legendItem.style.marginBottom = "5px";

				const colorCircle = L.DomUtil.create("div", "legend-color-circle", legendItem);
				colorCircle.style.width = "16px";
				colorCircle.style.height = "16px";
				colorCircle.style.borderRadius = "50%";
				colorCircle.style.backgroundColor = item.color;
				colorCircle.style.marginRight = "10px";

				const label = L.DomUtil.create("div", "legend-label", legendItem);
				label.innerText = item.label;
			});

			// Eventi per mostrare/nascondere la legenda
			legendButton.onclick = () => {
				dispatch({
					type: ACTIONS.SET_FILTER_MENU_OPEN,
					payload: state.filterMenuOpen === 3 ? 0 : 3,
				});
			};

			// Evita la propagazione degli eventi click
			L.DomEvent.disableClickPropagation(legendButton);
			L.DomEvent.disableClickPropagation(legendContainer);

			// Pulsante Aggiungi Pin
			if (canEdit) {
				const addPinButton = L.DomUtil.create("div", "add-pin-button", controlsContainer);
				addPinButton.style.cursor = "pointer";
				addPinButton.style.background = state.addPinEnabled ? "#4caf50" : "#f5f5f5";
				addPinButton.style.border = "1px solid #ccc";
				addPinButton.style.borderRadius = "5px";
				addPinButton.style.padding = "5px";
				addPinButton.style.width = "40px";
				addPinButton.style.height = "40px";
				addPinButton.style.display = "flex";
				addPinButton.style.alignItems = "center";
				addPinButton.style.justifyContent = "center";

				const addPinRoot = createRoot(addPinButton);
				addPinRoot.render(
					<LuMapPinPlus
						style={{
							fontSize: "24px",
							color: state.addPinEnabled ? "white" : "black",
						}}
					/>
				);

				addPinButton.onclick = () => {
					dispatch({ type: ACTIONS.TOGGLE_ADD_PIN });
				};
				L.DomEvent.disableClickPropagation(addPinButton);
				L.DomEvent.disableClickPropagation(controlsContainer);
			}

			// Eventi per mostrare/nascondere il menu
			filterButton.onclick = () => {
				dispatch({
					type: ACTIONS.SET_FILTER_MENU_OPEN,
					payload: state.filterMenuOpen === 1 ? 0 : 1,
				});
				menuContainer.style.display = state.filterMenuOpen === 1 ? "block" : "none";
			};

			groupFilterButton.onclick = () => {
				dispatch({
					type: ACTIONS.SET_FILTER_MENU_OPEN,
					payload: state.filterMenuOpen === 2 ? 0 : 2,
				});
				groupMenuContainer.style.display = state.filterMenuOpen === 2 ? "block" : "none";
			};

			L.DomEvent.disableClickPropagation(groupFilterButton);
			L.DomEvent.disableClickPropagation(filterButton);
			return container;
		};

		control.addTo(map);

		return () => {
			map.removeControl(control);
		};
	}, [
		map,
		state.selectedType,
		state.addPinEnabled,
		state.pinsGroups,
		state.filterMenuOpen,
		canEdit,
		dispatch,
		ACTIONS,
		content,
		isMonitor,
	]);

	return null;
};

export default FilterBar;
